module.exports = __webpack_public_path__ + "static/media/Vacuolo v8.44493fe4.glb";